module.exports = __webpack_public_path__ + "img/my_page.2326ee22.svg";